import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'; 
import cl from './ImageModal.module.css'
import ImageIcon from "../../../../assets/Icon/ImageIcon";
import ImageUploader from '../../../UI/ImageUploader/ImageUploader';
import automobyApi from '../../../../Api';
import { useAuth } from '../../../../providers/authProvider';
import { AppContext } from '../../../../providers/appProvider';

const ImageModal = ({ containerService, defaultContainer, disabled }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loadingImages, setLoadingImages] = useState([])
    const [arrivalImages, setArrivalImages] = useState([])
    const [buyImages, setBuyImages] = useState([])
    const {session} = useAuth(AppContext)
  
    useEffect(() => {
        setLoadingImages(defaultContainer.images_obj.loading) 
        setArrivalImages(defaultContainer.images_obj.arrival) 
        setBuyImages(defaultContainer.images_obj.buy) 

    }, [])

    const uploadImage = async (kind, acceptedFiles) => {
     
        const formData = new FormData();

        acceptedFiles.forEach((file) => {
            formData.append('images[]', file, file.name);
        });

        formData.append('containerid', defaultContainer.id.toString());
        formData.append('kind', kind);

        try {

            const response = await automobyApi.post("/container/image/upload", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setLoadingImages(response.data.loading)
            setArrivalImages(response.data.arrival)
            setBuyImages(response.data.buy)
            containerService.fetchList()
        } catch (error) {
            console.error('Error during file upload:', error);
            throw error;
        }
    }

    const deleteImage = async (kind, image) => {
       
        const requestData = {
            container_id: defaultContainer.id,
            kind: kind,
            image: image
        };
 
        try {
            const response = await automobyApi.post("/container/image/delete", requestData)

            setLoadingImages(response.data.loading)
            setArrivalImages(response.data.arrival)
            setBuyImages(response.data.buy)

        } catch (error) {
            console.error('Error during file upload:', error);
            throw error;
        }
    }
 
    const downloadImage = (name) => {
        containerService.downloadFile(defaultContainer.id, name)
    }
  
    return (
        <>



            {defaultContainer.images_obj.buy == '' && 
            defaultContainer.images_obj.loading == '' && 
            defaultContainer.images_obj.arrival == '' ? ( 
                <span className={cl.btnContainerTop} onClick={() => setIsModalOpen(true)}>
                    <span className={cl.icon  }><ImageIcon/> </span>
                    სურათები
                </span>
            ) : (
                    
                <span className={cl.btnContainerTop + ' ' + cl.btnGreen} onClick={() => setIsModalOpen(true)}>
                    <span className={cl.icon  }><ImageIcon/> </span>
                    სურათები  
                </span>
            )}
           
 

            <Modal size="large" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} ><ImageIcon /></span> სურათები
                    </h3>
                </div>

                <div style={{ position: 'relative', display: 'block' }}>
                    <div className={ cl.threeBox }>

                        <div className={ cl.col }>
                        <span className={ cl.downBTN }onClick={() => downloadImage("buy")}> გადმოწერა</span>

                            <ImageUploader images={buyImages}
                                uploadImage={uploadImage}
                                deleteImage={deleteImage}
                                title="ყიდვის სურათები" 
                                kind="buy"
                                disabled={disabled}
                                ></ImageUploader>
                        </div>

                        <div className={ cl.col }>
                            <span className={ cl.downBTN } onClick={() => downloadImage("loading")}> გადმოწერა</span>

                            <ImageUploader images={loadingImages}
                            uploadImage={uploadImage}
                            deleteImage={deleteImage}
                            title="ჩატვირთვის სურათები" 
                            kind="loading"
                            disabled={disabled}
                                                        ></ImageUploader> 
                        </div>
                        
                        <div className={ cl.col }>
                            
                            <span className={ cl.downBTN } onClick={() => downloadImage("arrival")}> გადმოწერა</span>

                            <ImageUploader 
                                images={arrivalImages}
                                uploadImage={uploadImage}
                                deleteImage={deleteImage}
                                title="გადმოტვირთვის სურათები" 
                                kind="arrival"
                                disabled={disabled}
                                > 
                            </ImageUploader>
                        </div>
                        
                    
                        
                    </div>
                </div>

            </Modal>


        </>
    );
};

export default ImageModal;